import { render, staticRenderFns } from "./invoiceType.vue?vue&type=template&id=b8436028&"
import script from "./invoiceType.vue?vue&type=script&lang=js&"
export * from "./invoiceType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports